import React, { useState, useLayoutEffect } from 'react'
import { Button } from 'core/components/button'
import { TextInput } from 'core/components/form/text-input'
import { useForm } from 'core/hooks/form'
import { requiredMessage } from 'core/constants'
import { localStore } from 'core/helpers/store'
import { config } from 'config'
import { loginRequest, API } from 'service'
import { ErrorMessage } from 'core/components/form/error-message'
import ReCAPTCHA from 'react-google-recaptcha'
import { CitySelect } from '../city'
import { Logo } from '../logo'

const namespace = config.NAMESPACE ? `${config.NAMESPACE}_` : ''

function tryLogin(login, route, form, global) {
  loginRequest({
    terminalTypeId: 2,
    cpfCnpj: login.cpfCnpj,
    password: login.password,
    cityId: login.city.id,
    captchaToken: login.captchaToken,
  })
    .then(resp => {
      const { user, parameters } = resp

      const operator = {
        user,
        parameters,
      }

      localStore.set(config.OPERATOR_KEY, operator)
      localStore.set(config.TOKEN_KEY, resp.accessToken)

      if (login.rememberMe) {
        localStorage.setItem(
          `${namespace}login`,
          JSON.stringify({ cpfCnpj: login.cpfCnpj, password: login.password }),
        )
      } else {
        localStorage.removeItem(`${namespace}login`)
      }

      return global.refresh()
    })
    .then(() => route.history.push(`/${login.city.name}`))
    .catch(err => {
      window.grecaptcha.reset()
      form.setErrors({ global: err.message })
    })
}

function recoverPassword(login, form, global, setPage) {
  API.post('password.customer', {
    cpfCnpj: login.cpfCnpj,
    cityId: login.city.id,
  })
    .then(resp => {
      const { email } = resp

      global.modal.alert(
        `Um e-mail foi enviado para ${email}.\nVerifique seu e-mail e siga as instruções.`,
      )

      setPage('login')
    })
    .catch(err => form.setErrors({ global: err.message }))
    .finally(() => form.setSubmitting(false))
}

function changePassword(token, login, form, global, setPage) {
  API.post('password.change', {
    token,
    password: login.password,
  })
    .then(() =>
      global.modal.alert(`Senha atualizada com sucesso.`, () => {
        setPage('login')
        form.setValues({ password: '' })
      }),
    )
    .catch(err => form.setErrors({ global: err.message }))
    .finally(() => form.setSubmitting(false))
}

export const LoginForm = ({
  form: { entity, errors, touched, handleChange, submitting, setValues },
  route,
  basename,
  setPage,
}) => (
  <>
    <div className="form-group validated">
      <TextInput
        autoComplete="cpfCnpj"
        customClassName="form-control-lg"
        icon="fas fa-user"
        meta={{
          error: errors.cpfCnpj,
          touched: touched.cpfCnpj,
        }}
        onChange={(cpfCnpj, type) =>
          handleChange({
            path: 'cpfCnpj',
            type,
            values: { cpfCnpj },
          })
        }
        placeholder="CPF/CNPJ"
        value={entity.cpfCnpj}
      />
    </div>
    <div className="form-group validated">
      <TextInput
        acceptEnter
        autoComplete="current-password"
        customClassName="form-control-lg"
        icon="fas fa-lock"
        meta={{
          error: errors.password,
          touched: touched.password,
        }}
        onChange={(password, type) =>
          handleChange({
            path: 'password',
            type,
            values: { password },
          })
        }
        placeholder="Senha"
        type="password"
        value={entity.password}
      />
    </div>

    <div className="form-group form-check">
      <input
        type="checkbox"
        className="form-check-input"
        id="rememberMe"
        checked={entity.rememberMe}
        onChange={ev => setValues({ rememberMe: ev.target.checked })}
      />
      <label className="form-check-label" htmlFor="rememberMe">
        Salvar senha
      </label>
    </div>

    <div className="recaptcha">
      <ReCAPTCHA
        onChange={captchaToken => {
          setValues({ captchaToken })
        }}
        sitekey="6LdRERoUAAAAAHvxprmXTb24rCkzAVEXD1XU6NkC"
      />
    </div>
    <div className="login-actions">
      <Button
        customClassName="btn-primary btn-lg btn-block btn-login"
        icon="fas fa-sign-in-alt"
        loading={submitting}
        title="Entrar"
      />
    </div>

    <ErrorMessage error={errors.global} />

    <div
      className="register-link"
      onClick={ev => {
        ev.preventDefault()
        route.history.push(`/${basename}/cadastro`)
      }}
    >
      <button type="button">Cadastrar-se</button>
      <i className="fas fa-angle-right" />
    </div>

    <div
      className="recover-link"
      onClick={ev => {
        ev.preventDefault()
        setPage('support')
      }}
    >
      <button type="button">Entrar em contato com suporte</button>
      <i className="fas fa-angle-right" />
    </div>

    <div
      className="recover-link"
      onClick={ev => {
        ev.preventDefault()
        setPage('forgot')
      }}
    >
      <button type="button">Esqueci minha senha</button>
      <i className="fas fa-angle-right" />
    </div>

    <div className="tel-info">Telefone: (19) 2660-2404</div>
  </>
)

const LoginForgot = ({ form: { entity, errors, touched, handleChange, submitting } }) => (
  <>
    <div className="form-group validated">
      <TextInput
        autoComplete="cpfCnpj"
        customClassName="form-control-lg"
        icon="fas fa-user"
        meta={{
          error: errors.cpfCnpj,
          touched: touched.cpfCnpj,
        }}
        onChange={(cpfCnpj, type) =>
          handleChange({
            path: 'cpfCnpj',
            type,
            values: { cpfCnpj },
          })
        }
        placeholder="CPF/CNPJ"
        value={entity.cpfCnpj}
      />
    </div>
    <div className="login-actions">
      <Button
        customClassName="btn-primary btn-lg btn-block"
        icon="fas fa-paper-plane"
        loading={submitting}
        title="Enviar"
      />
    </div>

    <ErrorMessage error={errors.global} />
  </>
)

const LoginSupport = ({ setPage }) => (
  <>
    <iframe
      src="https://itransit.tomticket.com/formulario?id=EP56171&account=3594944P16022022123116"
      title="Formulário Suporte"
      style={{ width: '100%', height: '500px', overflow: 'auto', borderWidth: 0 }}
    ></iframe>

    <a
      className="recover-link"
      href="https://itransit.tomticket.com/chat/?id=EP56171&ac=3594944P16022022123116"
      title="Acessar Atendimento Online"
      target="_blank"
      rel="noopener noreferrer"
    >
      <button type="button">Entrar em contato via chat</button>
      <i className="fas fa-angle-right" />
    </a>

    <div
      className="recover-link"
      onClick={ev => {
        ev.preventDefault()
        setPage('login')
      }}
    >
      <i className="fas fa-angle-left" />
      <button type="button">Voltar</button>
    </div>
  </>
)

const LoginSelect = ({ form: { entity, setValues }, global }) => (
  <>
    <div className="form-group">
      <CitySelect
        city={entity.city}
        global={global}
        onChange={city => setValues({ city })}
        styles={{
          control: base => ({ ...base, minHeight: '55px' }),
        }}
      />
    </div>
    <div className="login-actions">
      <Button
        customClassName="btn-primary btn-lg btn-block"
        icon="fas fa-arrow-right"
        title="Continuar"
      />
    </div>
  </>
)

const LoginRetry = ({ refresh }) => (
  <>
    <div className="retry-error">
      Não foi possível comunicar-se com nossos servidores, verifique sua conexão com a internet e
      tente novamente.
    </div>
    <div className="login-actions">
      <Button
        customClassName="btn-primary btn-lg btn-block"
        icon="fas fa-sync"
        onClick={refresh}
        title="Tentar Novamente"
      />
    </div>
  </>
)

const PasswordRecover = ({ form: { entity, errors, touched, handleChange, submitting } }) => (
  <>
    <div className="form-group validated">
      <TextInput
        acceptEnter
        autoComplete="current-password"
        customClassName="form-control-lg"
        icon="fas fa-lock"
        meta={{
          error: errors.password,
          touched: touched.password,
        }}
        onChange={(password, type) =>
          handleChange({
            path: 'password',
            type,
            values: { password },
          })
        }
        placeholder="Nova Senha"
        type="password"
        value={entity.password}
      />
    </div>
    <div className="form-group validated">
      <TextInput
        acceptEnter
        autoComplete="current-password"
        customClassName="form-control-lg"
        icon="fas fa-lock"
        meta={{
          error: errors.confirmPassword,
          touched: touched.confirmPassword,
        }}
        onChange={(confirmPassword, type) =>
          handleChange({
            path: 'confirmPassword',
            type,
            values: { confirmPassword },
          })
        }
        placeholder="Confirme a Nova Senha"
        type="password"
        value={entity.confirmPassword}
      />
    </div>
    <div className="login-actions">
      <Button
        customClassName="btn-primary btn-lg btn-block"
        icon="fas fa-paper-plane"
        loading={submitting}
        title="Enviar"
      />
    </div>

    <ErrorMessage error={errors.global} />
  </>
)

export const Login = ({ route, global }) => {
  const [page, setPage] = useState(null)
  const form = useForm(
    {
      initialEntity: {
        cpfCnpj: '',
        password: '',
        confirmPassword: '',
        city: null,
        captchaToken: '',
        rememberMe: false,
      },
      validate: values => {
        const errors = {}

        if (!values.cpfCnpj && (page === 'login' || page === 'forgot')) {
          errors.cpfCnpj = requiredMessage
        }

        if (!values.password && (page === 'login' || page === 'recover')) {
          errors.password = requiredMessage
        }

        if (!values.confirmPassword && page === 'recover') {
          errors.confirmPassword = requiredMessage
        }

        if (values.password !== values.confirmPassword && page === 'recover') {
          errors.confirmPassword = 'Senhas devem ser iguais.'
        }

        return errors
      },
    },
    route,
  )

  const { cities, loading, refresh, modal } = global
  const { history, match } = route
  const { city: cityName, token } = match.params
  const { city } = form.entity

  useLayoutEffect(() => {
    if (token) {
      setPage('recover')
      return
    }

    if (cities.length > 0 && !!cityName) {
      const loginDataJson = localStorage.getItem(`${namespace}login`)
      const loginData = loginDataJson ? JSON.parse(loginDataJson) : {}
      const selected = cities.find(c => c.name === cityName.toLowerCase())

      if (selected) {
        form.setValues({ ...loginData, rememberMe: Boolean(loginDataJson), city: selected })
        setPage('login')
        return
      }

      modal.alert('Cidade inválida ou não encontrada!')
      history.replace('/login')
    }

    form.setValues({ city: null })

    if (!loading && cities.length === 0) {
      setPage('retry')
      return
    }

    setPage('city')
    // eslint-disable-next-line
  }, [cities, cityName, loading])

  return (
    <div className="login-wrapper">
      <div className="login-box">
        {page === 'forgot' && (
          <button
            className="back"
            onClick={ev => {
              ev.preventDefault()
              setPage('login')
            }}
            tabIndex={0}
            type="button"
          >
            <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M7.284 24H46v2H7.284l14.074 18.392-1.588 1.216L4 25 19.77 4.392l1.588 1.216L7.284 24z"
                fill="#555"
                fillRule="nonzero"
              />
            </svg>
          </button>
        )}

        <div className="logo">
          <Logo isLogin />
        </div>

        <div className="login-title">
          {['login', 'forgot'].includes(page) && <h3>{`${city.fullName} - ${city.state}`}</h3>}
        </div>

        <form
          className="login-form"
          onSubmit={ev => {
            ev.preventDefault()

            if (page === 'recover' && token) {
              form.handleSubmit(ent => {
                changePassword(token, ent, form, global, setPage)
              })
              return
            }

            if (page === 'city') {
              if (!city) {
                return
              }

              history.replace(`/${city.name}/login`)
              setPage('login')
              return
            }

            if (page === 'forgot') {
              form.handleSubmit(ent => recoverPassword(ent, form, global, setPage))
              return
            }

            form.handleSubmit(ent => tryLogin(ent, route, form, global))
          }}
        >
          {page === 'city' && <LoginSelect form={form} global={global} />}
          {page === 'retry' && (
            <LoginRetry
              refresh={() => {
                refresh()
                setPage('city')
              }}
            />
          )}
          {page === 'login' && (
            <LoginForm basename={city.name} form={form} route={route} setPage={setPage} />
          )}
          {page === 'forgot' && <LoginForgot form={form} />}
          {page === 'support' && <LoginSupport setPage={setPage} />}
          {page === 'recover' && <PasswordRecover form={form} />}
        </form>
      </div>
    </div>
  )
}
